import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '';

const api = axios.create({
  baseURL: API_BASE,
});

// 업로드 이미지 등 정적 에셋 절대경로 생성 (dev: CRA 프록시로 :4000 전달)
export const assetUrl = (path?: string | null): string =>
  path ? `${API_BASE}${path}` : '';

export const configStepApi = {
  getAll: () => api.get('/api/config_step'),
  getWithOptions: () => api.get('/api/config_step/with_options'),
};

export const configOptionApi = {
  getAll: () => api.get('/api/config_option'),
  getByStep: (stepId: number) => api.get(`/api/config_option/by_step/${stepId}`),
};

export const configDependencyApi = {
  getAll: () => api.get('/api/config_dependency'),
  getChildren: (parentOptionId: number) =>
    api.get(`/api/config_dependency/children/${parentOptionId}`),
};

export const productApi = {
  getAll: () => api.get('/api/product'),
  getOne: (id: number) => api.get(`/api/product/${id}`),
  getByModel: (modelName: string) => api.get(`/api/product/model/${modelName}`),
};

export const productConfigApi = {
  match: (optionIds: number[]) =>
    api.get(`/api/product_config/match?option_ids=${optionIds.join(',')}`),
  all: () => api.get('/api/product_config/all'),
};

export const quoteRequestApi = {
  create: (data: { email: string; product_id?: number; selected_options?: any; message?: string }) =>
    api.post('/api/quote_request', data),
  send_quote: (formData: FormData) =>
    api.post('/api/quote_request/send_quote', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};

export const chatApi = {
  send: (message: string, history?: { role: string; content: string }[], lang?: 'ko' | 'en') =>
    api.post('/api/chat', { message, history, lang }),
};

export const pageVisitApi = {
  track: (data: { page_path: string; page_title?: string; referrer?: string; session_id?: string }) =>
    api.post('/api/page_visit', data).catch(() => {}),
};

export default api;
